export const DEVELOPER_PROJ_TABLE_SYSCODE = {
    Reserved: 0,
    SANDBOX: 1,
    STAGING: 2,
    PRODUCTION: 3,
}

export const DeveloperProjectTableSyscodeString = {
    [DEVELOPER_PROJ_TABLE_SYSCODE.Reserved]: "Reserved",
    [DEVELOPER_PROJ_TABLE_SYSCODE.SANDBOX]: "Sandbox",
    [DEVELOPER_PROJ_TABLE_SYSCODE.STAGING]: "Staging",
    [DEVELOPER_PROJ_TABLE_SYSCODE.PRODUCTION]: "Production"
}